import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { CachingInterceptor } from "./caching.interceptor";
import { PermissionsInterceptor } from "./permissions.interceptor";

export const interceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: PermissionsInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CachingInterceptor,
    multi: true,
  },
];
